import React, { useEffect, useState } from 'react';
//import { useLoaderData } from 'react-router-dom';
import Service from './Service';

const Services = () => {
    // const services = useLoaderData();
    // console.log(services);

    const [services, setServices] = useState([]);


    useEffect(() => {
        fetch('services.json')
            .then(res => res.json())
            .then(data => setServices(data))
    }, [])

    return (
        <div>
            <div className='text-center mt-12 mb-12'>
                <h2 className="text-4xl font-bold text-primary">Service Area</h2>
                <p>Interior or Exterior design Novelty Architect do everything. Make your house , office, hotel or <br />restaurant more better by Novelty Architect Ltd.</p>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>

                {
                    services.map(service => <Service
                        key={service._id}
                        service={service}

                    ></Service>)
                }

            </div>
        </div>
    );
};

export default Services;